"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var event_emitter_1 = require("@screencloud/event-emitter");
var UnixDate_1 = require("./lib/UnixDate");
function isNonEmptyString(str) {
    return typeof str === 'string' && !!str.trim();
}
function isAuthSession(session) {
    return typeof session === 'object'
        && typeof session.token === 'string'
        && session.token.startsWith('ey')
        && typeof session.claims === 'object'
        && isNonEmptyString(session.claims.email)
        && (isNonEmptyString(session.claims.connection) || session.claims.connection === undefined)
        && (isNonEmptyString(session.claims.provider) || session.claims.provider === undefined)
        && isNonEmptyString(session.claims.strategy)
        && session.claims.exp > 0;
}
exports.isAuthSession = isAuthSession;
function isAuthCache(x) {
    return typeof x === 'object'
        && x.date >= 0
        && isAuthSession(x.session);
}
exports.isAuthCache = isAuthCache;
function isAuthSessionError(x) {
    return typeof x === 'object'
        && typeof x.message === 'string';
}
exports.isAuthSessionError = isAuthSessionError;
exports.StorageKeyName = 'sc_auth_session';
var Auth = /** @class */ (function (_super) {
    __extends(Auth, _super);
    function Auth(config) {
        var _this = _super.call(this) || this;
        _this.cache = { date: 0, session: null };
        _this.service = __assign({}, config.service);
        _this.frontend = __assign({}, config.frontend);
        _this.storageKey = config.storageKey || exports.StorageKeyName;
        _this.debug = config.debug === true || document.cookie.split(/;\s*/).includes('DEBUG_AUTH_SDK=1');
        _this.autoRefresh = !!config.autoRefresh;
        _this.autoSync = !!config.autoSync;
        return _this;
    }
    Object.defineProperty(Auth.prototype, "autoSync", {
        get: function () {
            return !!this.storageHandler;
        },
        set: function (value) {
            var _this = this;
            if (!value && this.storageHandler) {
                this.log("autoSync(" + value + "): deactivate");
                removeEventListener('storage', this.storageHandler);
                this.storageHandler = undefined;
            }
            else if (value && !this.storageHandler) {
                this.log("autoSync(" + value + "): activate");
                addEventListener('storage', this.storageHandler = function (event) {
                    // ignore other keys, as well as null and unchanged values
                    if (event.key !== _this.storageKey || !event.newValue || event.newValue === event.oldValue) {
                        return;
                    }
                    _this.log("autoSync: received storage-event with ");
                    // if value is compatible to us, accept it, otherwise ignore
                    try {
                        var newCache = JSON.parse(event.newValue);
                        if (isAuthCache(newCache)) {
                            _this.log("autoSync: received valid cache state");
                            _this.setCache(newCache.session, newCache.date);
                        }
                        else {
                            _this.log("autoSync: received and ignored invalid cache state");
                        }
                    }
                    catch (e) {
                        _this.log("autoSync: storage event value failed JSON.parse()");
                    }
                });
                this.storageHandler = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Auth.prototype, "autoRefresh", {
        get: function () {
            return !!this.refreshHandle;
        },
        set: function (value) {
            var _this = this;
            if (!value && this.refreshHandle) {
                this.log("autoRefresh(" + value + "): deactivate");
                clearInterval(this.refreshHandle);
                this.refreshHandle = undefined;
            }
            else if (value && !this.refreshHandle) {
                this.log("autoRefresh(" + value + "): activate");
                this.refreshHandle = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!this.shouldRefresh()) return [3 /*break*/, 2];
                                this.log("autoRefresh: performing refresh()");
                                return [4 /*yield*/, this.refresh()];
                            case 1:
                                _a.sent();
                                return [3 /*break*/, 3];
                            case 2:
                                this.log("autoRefresh: skipped");
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); }, 15 * 1000);
            }
        },
        enumerable: true,
        configurable: true
    });
    Auth.prototype.fetchJson = function (path, init) {
        if (init === void 0) { init = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var body, method, url, start, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = typeof init.body === 'object'
                            ? JSON.stringify(init.body)
                            : undefined;
                        method = init.method || (init.body ? 'POST' : 'GET');
                        url = "" + this.service.url + path;
                        start = Date.now();
                        this.log("fetchJson() " + method + " " + path);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        // call fetch
                        // ... merge provided init, with determined and default options
                        return [4 /*yield*/, fetch(url, __assign(__assign(__assign({}, init), (body !== undefined ? { body: body } : {})), { method: method, headers: __assign(__assign({}, init.headers), { 
                                    // enforce certain headers
                                    'Accept': 'application/json', 'Content-Type': 'application/json' }), 
                                // ensure credentials
                                credentials: 'include' }))];
                    case 2: return [4 /*yield*/, (
                        // call fetch
                        // ... merge provided init, with determined and default options
                        _a.sent()).json()];
                    case 3:
                        response = _a.sent();
                        this.log("fetchJson() " + method + " " + path + " took " + (Date.now() - start) + "ms");
                        return [2 /*return*/, response];
                    case 4:
                        e_1 = _a.sent();
                        this.log("fetchJson() " + method + " " + path + " failed after " + (Date.now() - start) + "ms");
                        throw new Error('UNEXPECTED_API_RESULT');
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_2, error, claims, token, session;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log('refresh()', 'called');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fetchJson('/token/refresh')];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this.setCache(null);
                        // rethrow
                        throw e_2;
                    case 4:
                        error = response.error, claims = response.claims, token = response.token;
                        // error message received, throw to forward
                        if (isAuthSessionError(error)) {
                            this.log('refresh() received error message', error);
                            this.setCache(null);
                            throw new Error(response.error.message);
                        }
                        session = { claims: claims, token: token };
                        if (!isAuthSession(session)) {
                            this.log('refresh() received invalid payload', response);
                            this.setCache(null);
                            throw new Error('INVALID_REFRESH_RESULT');
                        }
                        // store session
                        this.log('refresh()', 'received session passed validation');
                        this.setCache(session);
                        return [2 /*return*/, session];
                }
            });
        });
    };
    Auth.prototype.setCache = function (session, date) {
        // grab some things that will change
        var isFirst = !this.cache || !this.cache.date;
        var prevSession = this.cache.session;
        // store new session
        var cache = { date: date || Date.now(), session: session };
        this.log('setCache() store session', cache.date);
        this.cache = cache;
        if (localStorage) {
            localStorage.setItem(this.storageKey, JSON.stringify(cache));
        }
        // fire initialized once
        if (isFirst) {
            this.log('store() emit initialized-event');
            this.emit('initialized', JSON.parse(JSON.stringify(session)));
        }
        // loggedIn: from null
        else if (!prevSession && session) {
            this.log('store() emit loggedIn-event');
            this.emit('loggedIn', JSON.parse(JSON.stringify(session)));
        }
        // loggedIn: from other loggedIn
        else if (prevSession && session && (prevSession.claims.email !== session.claims.email
            || prevSession.claims.connection !== session.claims.connection
            || prevSession.claims.provider !== session.claims.provider)) {
            this.log('store() emit loggedIn-event');
            this.emit('loggedIn', JSON.parse(JSON.stringify(session)));
        }
        // loggedOut
        else if (prevSession && !session) {
            this.log('store() emit loggedOut-event');
            this.emit('loggedOut', { redirectUrl: this.frontend.url });
        }
        // refreshed
        else if (prevSession && session && (prevSession.claims.email === session.claims.email
            && prevSession.claims.connection === session.claims.connection
            && prevSession.claims.provider === session.claims.provider
            && prevSession.claims.exp !== session.claims.exp)) {
            this.log('store() emit refreshed-event');
            this.emit('refreshed', JSON.parse(JSON.stringify(session)));
        }
    };
    Auth.prototype.shouldRefresh = function () {
        // nothing was ever cached
        if (!this.cache || !this.cache.date) {
            this.log('shouldRefresh()', 'no cache available');
            return true;
        }
        // cache is outdated
        else if (Date.now() - this.cache.date >= 1000 * 60 * 5) {
            this.log('shouldRefresh() cache expires soon', Date.now() - this.cache.date);
            return true;
        }
        // cached payload expires soon
        else if (this.cache.session && (this.cache.session.claims.exp - UnixDate_1.UnixDate.now()) < 60 * 2) {
            this.log('shouldRefresh()', 'cached payload expires soon');
            return true;
        }
        return false;
    };
    Auth.prototype.get = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_3, _a, email, provider, connection;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.log('shouldRefresh()', 'called');
                        if (!this.shouldRefresh()) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.refresh()];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _b.sent();
                        return [2 /*return*/, null];
                    case 4:
                        if (this.debug) {
                            if (!this.cache.session) {
                                this.log('get()', "no session found");
                            }
                            else {
                                _a = this.cache.session.claims, email = _a.email, provider = _a.provider, connection = _a.connection;
                                this.log('get()', "session found", email, connection, provider);
                            }
                        }
                        // return cache
                        return [2 /*return*/, this.cache.session];
                }
            });
        });
    };
    Auth.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log('logout()', 'called');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fetchJson('/api/v1/user/logout', {
                                method: 'POST',
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        this.log('logout() api call failed after', e_4);
                        return [3 /*break*/, 4];
                    case 4:
                        // store null, will trigger other tabs
                        this.setCache(null);
                        // reply with event data
                        this.log('logout() done');
                        return [2 /*return*/, { redirectUrl: this.frontend.url }];
                }
            });
        });
    };
    // eslint-disable-next-line max-len
    Auth.prototype.fetchApiResponse = function (path, body, logPrefix) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.log(logPrefix + " called", body);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fetchJson("/api/v1/" + path, {
                                method: 'POST',
                                body: body,
                            })];
                    case 2:
                        result = _a.sent();
                        this.log(logPrefix + " received", result);
                        return [2 /*return*/, result];
                    case 3:
                        e_5 = _a.sent();
                        this.log(logPrefix + " api call failed after", e_5);
                        throw e_5;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Auth.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.debug) {
            console.log.apply(console, __spreadArrays(['AuthSdk.Auth:'], args));
        }
    };
    return Auth;
}(event_emitter_1.EventEmitter));
exports.Auth = Auth;
